import { useEffect } from 'react';
import { useColumnPreferences } from '../context/ColumnPreferencesContext';

/**
 * Hook for entity list pages to get column state.
 * Automatically loads preferences on mount.
 *
 * Usage:
 *   const { visibleColumns, allColumns } = useColumns('accounts');
 */
function useColumns(entityType) {
  const {
    loadColumns,
    getVisibleColumns,
    getAllColumns,
    loading,
  } = useColumnPreferences();

  useEffect(() => {
    loadColumns(entityType);
  }, [entityType, loadColumns]);

  return {
    visibleColumns: getVisibleColumns(entityType),
    allColumns: getAllColumns(entityType),
    loading: loading[entityType] || false,
  };
}

export default useColumns;
